/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSocialLikeBody
 */
export interface EarnSocialLikeBody {
    /**
     * 
     * @type {string}
     * @memberof EarnSocialLikeBody
     */
    objectiveTemplateId: string;
    /**
     * 
     * @type {string}
     * @memberof EarnSocialLikeBody
     */
    postUrl: string;
}

/**
 * Check if a given object implements the EarnSocialLikeBody interface.
 */
export function instanceOfEarnSocialLikeBody(value: object): value is EarnSocialLikeBody {
    if (!('objectiveTemplateId' in value) || value['objectiveTemplateId'] === undefined) return false;
    if (!('postUrl' in value) || value['postUrl'] === undefined) return false;
    return true;
}

export function EarnSocialLikeBodyFromJSON(json: any): EarnSocialLikeBody {
    return EarnSocialLikeBodyFromJSONTyped(json, false);
}

export function EarnSocialLikeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSocialLikeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'],
        'postUrl': json['postUrl'],
    };
}

export function EarnSocialLikeBodyToJSON(json: any): EarnSocialLikeBody {
    return EarnSocialLikeBodyToJSONTyped(json, false);
}

export function EarnSocialLikeBodyToJSONTyped(value?: EarnSocialLikeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'postUrl': value['postUrl'],
    };
}

